import { render, staticRenderFns } from "./OngletEconomie.vue?vue&type=template&id=6a0102de&scoped=true"
import script from "./OngletEconomie.vue?vue&type=script&lang=js"
export * from "./OngletEconomie.vue?vue&type=script&lang=js"
import style0 from "./OngletEconomie.vue?vue&type=style&index=0&id=6a0102de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0102de",
  null
  
)

export default component.exports